import { render, staticRenderFns } from "./VideoUserInfo.vue?vue&type=template&id=2a9d661c&scoped=true&"
import script from "./VideoUserInfo.vue?vue&type=script&lang=ts&"
export * from "./VideoUserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VideoUserInfo.vue?vue&type=style&index=0&id=2a9d661c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9d661c",
  null
  
)

export default component.exports